import { ColumnProps, SortOrder } from 'antd/lib/table';
import { Sorting } from 'src/types/Sorting';
import { AuditItem } from '../../../../types/scriptConfiguration';

export type ColumnId = keyof AuditItem;

export type ColumnSorting = Sorting<AuditItem> & {
  field: ColumnId;
};

export type AuditItemColumn = ColumnProps<AuditItem> & { dataIndex: ColumnId };

const renderEmails = (val: string | null) => {
  if (val === null || val === 'null') {
    return 'N/A';
  }
  return val.replaceAll(',', ', ');
};

const columns: AuditItemColumn[] = [
  {
    title: 'Date',
    dataIndex: 'dateStamp',
    sorter: true,
    width: 100,
  },
  {
    title: 'User',
    dataIndex: 'userId',
    sortDirections: ['ascend', 'descend'],
    sorter: (a: AuditItem, b: AuditItem) => {
      return a.userId.localeCompare(b.userId);
    },
    width: 100,
  },
  {
    title: 'New value',
    dataIndex: 'newValue',
    sorter: (a: AuditItem, b: AuditItem) => compareValues(a.newValue, b.newValue),
    render: renderEmails,
    width: 100,
  },
  {
    title: 'Old value',
    dataIndex: 'oldValue',
    sorter: (a: AuditItem, b: AuditItem) => compareValues(a.oldValue, b.oldValue),
    render: renderEmails,
    width: 100,
  },
];

export const getColumns = (sorting: ColumnSorting): AuditItemColumn[] => {
  const sortOrder = (key: ColumnId): SortOrder | false => {
    return sorting.field === key ? sorting.order : false;
  };

  const sortedColumns = columns.map((column) => ({
    ...column,
    sortOrder: sortOrder(column.dataIndex),
  }));

  return sortedColumns;
};

const compareValues = (valueA: string | null | undefined, valueB: string | null | undefined) => {
  if (valueA == null && valueB == null) return 0;
  if (valueA == null) return -1;
  if (valueB == null) return 1;
  const numA = parseFloat(valueA);
  const numB = parseFloat(valueB);
  if (!isNaN(numA) && !isNaN(numB)) {
    return numA - numB;
  }
  return valueA.localeCompare(valueB);
};
